import clsx from 'clsx'
import useWishlist from 'hooks/useWishlist'
import Icon from 'snippets/icon/icon'
import LoaderSpin from 'snippets/loader-spin/loader-spin'

export default function WishlistButton({
  product,
  variantSelected,
  className = 'absolute z-2 top-3 right-3 lg:top-[22px] lg:right-5',
  classIcon = 'size-4 text-neutral-900',
  activeClass = 'fill-neutral-700',
  isProductForm,
  isWishlistCard,
  disabled = false
}) {
  const { isAdded, handleWishlist, isLoading } = useWishlist(product, variantSelected, isProductForm)
  const iconName = isWishlistCard ? 'icon-close' : 'icon-heart'

  const handleWishlistToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (window.GM_STATE.customer.logged) {
      handleWishlist()
    } else {
      const currentUrl = window.location.pathname + window.location.search
      const separator = currentUrl.includes('?') ? '&' : '?'
      const urlWithWishlistParam = `${currentUrl}${separator}variant_id=${variantSelected}&product_id=${product.id}`
      const returnTo = encodeURIComponent(urlWithWishlistParam)

      window.location.href = `/customer_identity/login?return_to=${returnTo}`
    }
  }

  return (
    <button
      type="button"
      className={className}
      onClick={handleWishlistToggle}
      aria-label={`Add ${product?.title || 'product'} to wishlist`}
      disabled={disabled}
    >
      {isLoading ? (
        <LoaderSpin size={isProductForm ? 4 : 3.5} />
      ) : (
        <Icon
          name={iconName}
          viewBox="0 0 16 16"
          className={clsx(classIcon, isAdded && activeClass, disabled && '!text-neutral-300')}
        />
      )}
    </button>
  )
}
